import { ReactNode } from 'react';

interface PremiumContainerProps {
  children: ReactNode;
  className?: string;
}

export default function PremiumContainer({ children, className = '' }: PremiumContainerProps) {
  return (
    <main 
      className={`
        flex-1 w-full
        overflow-y-auto overflow-x-hidden
        ${className}
      `}
      style={{ 
        flex: '1 1 0%', 
        minHeight: '100%', 
        width: '100%', 
        maxWidth: '100%',
        minWidth: '100%',
        height: '100%',
        maxHeight: '100%',
        display: 'flex', 
        flexDirection: 'column', 
        margin: 0, 
        padding: 0, 
        position: 'relative', 
        boxSizing: 'border-box', 
        overflow: 'hidden',
        zIndex: 1,
        backgroundColor: 'transparent'
      }}
    >
      {children}
    </main>
  );
}
